import { render } from "./LecturesAbout.vue?vue&type=template&id=4dfacd1c"
import script from "./LecturesAbout.vue?vue&type=script&lang=js"
export * from "./LecturesAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__